import React from 'react';
import { Link } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';

const NotFound = () => (
  <div className="rihen-site flex min-h-screen items-center justify-center">
    <div className="rihen-grain" aria-hidden="true" />
    <div className="rihen-site-inner py-20 text-center">
      <p className="font-mono text-sm uppercase tracking-[0.2em] text-rihen-gold">Erreur 404</p>
      <h1 className="mt-4 font-display text-8xl font-bold text-rihen-teal md:text-9xl">404</h1>
      <h2 className="mt-4 font-display text-3xl font-bold text-dark md:text-4xl">Page introuvable</h2>
      <p className="mx-auto mt-4 max-w-lg text-lg text-text/70">
        Oups ! La page que vous recherchez semble avoir été déplacée, supprimée ou n'existe pas.
      </p>
      <div className="mt-10 flex flex-col justify-center gap-4 sm:flex-row">
        <Link to="/" className="rihen-btn rihen-btn-primary interactive-button inline-flex items-center justify-center">
          <Home className="mr-2" size={20} />
          Retour à l'accueil
        </Link>
        <button
          type="button"
          onClick={() => window.history.back()}
          className="rihen-btn rihen-btn-outline interactive-button inline-flex items-center justify-center"
        >
          <ArrowLeft className="mr-2" size={20} />
          Page précédente
        </button>
      </div>
    </div>
  </div>
);

export default NotFound;
